import React from 'react';
import { isDaylightSavingTime } from '../../../utils/functions';
import { DAYS, MONTHS } from '../../../utils/variables';

export default function AppointmentInfo({ orderPackage }) {
  let [dateVal, timeVal] = orderPackage.appointmentTime.split(' ');

  timeVal = timeVal.split(':');

  if (!isDaylightSavingTime()) {
    timeVal[0] = (parseInt(timeVal[0], 10) + 8).toString();
  } else {
    timeVal[0] = (parseInt(timeVal[0], 10) + 7).toString();
  }

  timeVal = timeVal.join(':');

  const dateString = `${dateVal}T${timeVal}+00:00`;

  const date = new Date(Date.parse(dateString));

  return (
    <div style={{ marginTop: '8px', marginBottom: '8px', fontWeight: 'bold' }}>
      Appointment Info:
      {' '}
      {DAYS[date.getDay()]}
      {', '}
      {MONTHS[date.getMonth()]}
      {' '}
      {date.getDate()}
      {' '}
      at
      {' '}
      {date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })}
    </div>
  );
}
